export default __webpack_public_path__ + "static/media/07_Spot-5-Birds_Share.ca2d1c6f.jpg";